import { RebateProgram, AddressDetailsModel, SapnMacActivityType, Scheme } from './quote.model';

export interface QuoteV2CreateModel {
    scope: Scheme;

    // Customer Information for creating new customers
    customerFirstName: string;
    customerMiddleName?: string;
    customerLastName: string;
    customerEmail: string;
    customerMobile: string;
    isEnergyConcessionHolder: boolean;
    receivesDistributionFeedInTariff: boolean;

    // Loan/Balance Calculation Parameters
    installationPrice: number;
    customerDeposit: number;
    systemDetails: SystemDetail[];
    isPriceGstInc: boolean;
    optInFinance?: boolean;
    isTotalIncomeLessThanThreshold?: boolean;
    financeAmount?: number;

    // Other system information
    installationTypes: string[];
    intendedInstallationDate: Date;
    installationAddress: AddressDetailsModel;
    existingSolarPanels: boolean;
    existingBattery: boolean;
    hasExistingInverter?: boolean;
    numberOfBatteries: number;

    validUntil: Date;
    isEaas: boolean;
    nationalMeterIdentifier: string;
    installationAddressIsPredominantResidential: boolean;
    activities: ActivityModel[];
}

export interface QuoteV2PatchModel {
    scope: string;
    customerFirstName: string;
    customerLastName: string;

    unitNumber: string;
    streetNumber: string;
    street: string;
    suburb: string;
    postCode: string;
    state: string;

    nationalMeterIdentifier: string;
    intendedInstallationDate: Date;
    installationTypes: string[];
    hasExistingInverter?: boolean;

    systemDetails: SystemDetail[];
    activities: ActivityModel[];
    installationPrice: number;
    customerDeposit: number;
    optInFinance?: boolean;
    isTotalIncomeLessThanThreshold?: boolean;
    financeAmount?: number;
    accreditationNumbers?: string[];
}

export class ActivityModel {
    activityType: SapnMacActivityType;
    associatedRebate: string;
    rebateAmount: number;
    vpp: string;
    systemAndInstallationCost: number;
    additionalCost: number;
    subtotal: number;
}

export interface SystemDetail {
    type: string;
    packageExternalId: string;
    price: number;
    systemModelIdentifier: string;
}

export enum NotificationType {
    ResendRebateEmail = 'ResendRebateEmail',
    SendFinanceEmail = 'SendFinanceEmail'
}

export interface ResendNotificationRequestModel {
    notificationTypes: NotificationType[];
}
